import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegisterCommunicationComponent } from './pages/register/register-communication/register-communication.component';
import { RegisterCommunicationNewComponent } from './pages/register/register-communication-new/register-communication-new.component';
import { RegisterCommunicationEditComponent } from './pages/register/register-communication-edit/register-communication-edit.component';
import { RegisterProductComponent } from './pages/register/register-product/register-product.component';
import { RegisterProductEditComponent } from './pages/register/register-product-edit/register-product-edit.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { ReportComponent } from './pages/report/report.component';

const routes: Routes = [
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'register/communication', component: RegisterCommunicationComponent },
  { path: 'register/communication/new', component: RegisterCommunicationNewComponent },
  { path: 'register/communication/:id', component: RegisterCommunicationEditComponent },
  { path: 'register/product', component: RegisterProductComponent },
  { path: 'register/product/new', component: RegisterProductEditComponent },
  { path: 'register/product/:id', component: RegisterProductEditComponent },
  { path: 'report', component: ReportComponent },
  {
    path: 'register/highlight',
    loadChildren: () =>
      import('./pages/register/register-highlight/register-highlight.module').then(
        m => m.RegisterHighlightModule
      ),
  },
  {
    path: 'register/product-type',
    loadChildren: () =>
      import('./pages/register/register-product-type/register-product-type.module').then(
        m => m.RegisterProductTypeModule
      ),
  },
  { path: '', component: RedirectComponent },
  { path: '**', component: RedirectComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
